// extracted by mini-css-extract-plugin
module.exports = {"card":"add-story-card_card__38vzZ","icon":"add-story-card_icon__1zgYh","title":"add-story-card_title__Xz0Sr"};